module.exports = __webpack_public_path__ + "img/search.1d5024d7.svg";